import {Module} from 'module/Module'
import {MemoReducerNS} from 'module/Memo/reducer/MemoReducer'

// atm only used in custom field cfAttr. When used by Property, do not forget to add this module as dependency
export const MemoModule: Module = {
	reducerNS: MemoReducerNS,
}